/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { forexListPrices } from "../../funcs/forexListPrices.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$forexListPrices: ToolDefinition = {
  name: "forex-list-prices",
  description: `Get most recent forex prices for all currencies

Get most recent forex prices for all currencies`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await forexListPrices(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
